import React, { useState, useEffect, useReducer } from 'react'
import { Col, Panel, Row, IconButton, Icon, ButtonGroup, Message, CheckPicker, Input, SelectPicker, InputNumber } from 'rsuite'
import { startLoading, doneLoading } from '../../utils/loading'
import notification from '../../utils/notification'
import {
  exportEfillingSummaryReport,
  searchEfillingSummaryReport,
} from '../../redux/actions/eFilling'
import { downloadFile } from '../../utils/fileUtil'
import { getValueFromOptions } from '../../utils/dataUtil'
import OverallBudgetReportTable from './OverallBudgetReportTable'
import DatePickerCustom from '../../components/datePicker/DatePickerCustom'
import NumberFormat from 'react-number-format'
import classNames from 'classnames'
import moment from 'moment'
import SearchButton from '../../components/buttons/searchButton/SearchButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { exportOverallBudgetReportReport, searchOverallBudgetReportReport } from '../../redux/actions/overallBudgetReport'
import ButtonPanelWidget from '../ButtonPanelWidget'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'

export default function OverallBudgetReportWidget(props) {
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isExpanded, setIsExpanded] = useState(true)
  const projectCode = sessionStorage.getItem('projectCode')
  const [_, forceUpdate] = useReducer((x) => x + 1, 0)
  const [searchData, setSearchData] = useState()
  const [isLoading, setIsLoading] = useState(false)
  
  const [budgetYearStartValue, setBudgetYearStartValue] = useState(null);
  const [budgetYearEndValue, setBudgetYearEndValue] = useState(null);
  const [departmentValue, setDepartmentValue] = useState(null);
  const [startDateValue, setStartDateValue] = useState(null);
  const [endDateValue, setEndDateValue] = useState(null);
  const [monthValue, setMonthValue] = useState(null);
  const [projectNoValue, setProjectNoValue] = useState(null);
  const [projectCodeValue, setProjectCodeValue] = useState(null);
  const [projectStatusValue, setProjectStatusValue] = useState(null);
  const [projectStartDateValue, setProjectStartDateValue] = useState(null);
  const [projectEndDateValue, setProjectEndDateValue] = useState(null);

  useEffect(() => {
    // setVoucherSchema(mockSchema.model || [])
  }, [])

  const handleSearch = async () => {
    setIsLoading(true)
    startLoading()

    const request = {
      budgetYearStart: budgetYearStartValue,
      budgetYearEnd: budgetYearEndValue,
      department: departmentValue,
      startDate: startDateValue,
      endDate: endDateValue,
      month: monthValue || 0,
      projectNo: projectNoValue,
      projectCode: projectCodeValue,
      projectStatus: projectStatusValue,
      projectStartDate: projectStartDateValue,
      projectEndDate: projectEndDateValue
    };

    try {
      const response = await searchOverallBudgetReportReport(request)
      setFormSchema(response.model)
    } catch (error) {
      console.log('error ', error)
    }

    doneLoading()
    setIsLoading(false)
  }

  const handleExportFile = async () => {
    setIsLoading(true)
    startLoading()

    const request = {
      budgetYearStart: budgetYearStartValue,
      budgetYearEnd: budgetYearEndValue,
      department: departmentValue,
      startDate: startDateValue,
      endDate: endDateValue,
      month: monthValue || 0,
      projectNo: projectNoValue,
      projectCode: projectCodeValue,
      projectStatus: projectStatusValue,
      projectStartDate: projectStartDateValue,
      projectEndDate: projectEndDateValue
    };

    try {
      const file = await exportOverallBudgetReportReport(request)

      if (file) {
        downloadFile(file, `รายงานภาพรวมการเบิกจ่าย และเงินเหลือคืนของเงินอุดหนุนโครงการ.xlsx`)
      } else {
        notification.open('error', {
          title: 'ไม่สามารถทำรายการได้ กรุณาลองใหม่หรือติดต่อผู้ดูแลระบบ',
          duration: 5000,
        })
      }
    } catch (e) {
      //let errorJson = JSON.parse(await e.response.data.text())
      console.log('handleExportFile error : ', e.response)
      notification.open('error', {
        title: e?.response?.data?.errorMessage || e?.errors?.message || 'ไม่สามารถทำรายการได้ กรุณาลองใหม่หรือติดต่อผู้ดูแลระบบ',
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const resetSearchForm = () => {
    setBudgetYearStartValue(null);
    setBudgetYearEndValue(null);
    setDepartmentValue(null);
    setStartDateValue(null);
    setEndDateValue(null);
    setMonthValue(null);
    setProjectNoValue("");
    setProjectCodeValue("");
    setProjectStatusValue(null);
    setProjectStartDateValue(null);
    setProjectEndDateValue(null);
  }

  return (
    <>
      <Panel
        shaded
        // collapsible
        defaultExpanded
        bordered
        header={' '}
        expanded={isExpanded}
        onSelect={() => {
          setIsExpanded(!isExpanded)
          setTimeout(() => {
            forceUpdate()
          }, 100)
        }}
      >
        {/* ปีงบประมาณเริ่มต้น - ปีงบประมาณสิ้นสุด */}
        <Row style={{ marginBottom: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {formSchema.forms.searchForm.budgetYearStart.label}
            <InputNumber
              placeholder={'พ.ศ.'}
              value={budgetYearStartValue}
              onChange={(value) => {
                setBudgetYearStartValue(value)
              }}
            />
            {/* <NumberFormat
              className={classNames('rs-input')}
              thousandSeparator={true}
              value={budgetYearStartValue}
              onValueChange={(value) => {
                console.log(value)
                setBudgetYearStartValue(value.floatValue)
              }}
            /> */}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {formSchema.forms.searchForm.budgetYearEnd.label}
            <InputNumber
              placeholder={'พ.ศ.'}
              value={budgetYearEndValue}
              onChange={(value) => {
                setBudgetYearEndValue(value)
              }}
            />
            {/* <NumberFormat
              className={classNames('rs-input')}
              thousandSeparator={true}
              value={budgetYearEndValue}
              onValueChange={(value) => {
                setBudgetYearEndValue(value.floatValue)
              }}
            /> */}
          </Col>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
        </Row>

        {/* ช่วงเวลาวันที่เริ่มต้น - เวลาวันที่สิ้นสุด */}
        {/* <Row style={{ marginBottom: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {formSchema.forms.searchForm.startDate.label}
            <DatePickerCustom
              value={startDateValue}
              onChange={(value) => {
                setStartDateValue(value)
              }}
              placement="auto"
              disabledDate={(date) =>
                endDateValue && moment(endDateValue).isBefore(date, new Date())
              }
            />
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {formSchema.forms.searchForm.endDate.label}
            <DatePickerCustom
              value={endDateValue}
              onChange={(value) => {
                setEndDateValue(value)
              }}
              placement="auto"
              disabledDate={(date) =>
                startDateValue && moment(startDateValue).isAfter(date, new Date())
              }
            />
          </Col>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
        </Row> */}

        {/* เดือน, เลขที่โครงการ */}
        {/* <Row style={{ marginBottom: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {formSchema.forms.searchForm.month.label}
            <SelectPicker
              searchable={false}
              value={monthValue}
              data={formSchema.forms.searchForm.month.options}
              block
              onChange={(value) => {
                setMonthValue(value)
              }}
            />
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {formSchema.forms.searchForm.projectNo.label}
            <Input
              value={projectNoValue}
              onChange={(value) => {
                setProjectNoValue(value)
              }}
            />
          </Col>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
        </Row> */}

        {/* สำนัก, รหัสโครงการ */}
        <Row style={{ marginBottom: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {formSchema.forms.searchForm.department.label}
            <SelectPicker
              searchable={false}
              value={departmentValue}
              data={formSchema.forms.searchForm.department.options}
              block
              onChange={(value) => {
                setDepartmentValue(value)
              }}
            />
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {formSchema.forms.searchForm.projectCode.label}
            <Input
              value={projectCodeValue}
              onChange={(value) => {
                setProjectCodeValue(value)
              }}
            />
          </Col>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
        </Row>

        {/* วันที่เริ่มต้นโครงการ - วันที่สิ้นสุดโครงการ */}
        <Row style={{ marginBottom: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {formSchema.forms.searchForm.projectStartDate.label}
            <DatePickerCustom
              value={projectStartDateValue}
              onChange={(value) => {
                setProjectStartDateValue(value)
              }}
              placement="auto"
              disabledDate={(date) =>
                projectEndDateValue && moment(projectEndDateValue).isBefore(date, new Date())
              }
            />
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {formSchema.forms.searchForm.projectEndDate.label}
            <DatePickerCustom
              value={projectEndDateValue}
              onChange={(value) => {
                setProjectEndDateValue(value)
              }}
              placement="auto"
              disabledDate={(date) =>
                projectStartDateValue && moment(projectStartDateValue).isAfter(date, new Date())
              }
            />
          </Col>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
        </Row>

        {/* สถานะโครงการ */}
        <Row style={{ marginBottom: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {formSchema.forms.searchForm.projectStatus.label}
            <SelectPicker
              searchable={false}
              value={projectStatusValue}
              data={formSchema.forms.searchForm.projectStatus.options}
              block
              onChange={(value) => {
                setProjectStatusValue(value)
              }}
            />
          </Col>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
        </Row>

        {isLoading && <OverlayLoader />}

        <Row style={{ marginBottom: 20, marginTop: 30 }}>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
          <Col lg={20} md={20} sm={24} xs={24}>
          <ButtonPanelWidget
              isEdit={true}
              // isError={isError}
              buttonText={formSchema?.forms?.buttonText}
              onPreview={handleSearch}
              onPrint={handleExportFile}
              onCancel={resetSearchForm}
            />
            {/* <SearchButton disabled={false} onClick={handleSearch}>
              ค้นหา
            </SearchButton>
            <CancelButton disabled={false} onClick={resetSearchForm}>
              ยกเลิก
            </CancelButton>

            <IconButton
              appearance="ghost"
              icon={<Icon icon="file-pdf-o" className="bt-gost-icon-radius" />}
              onClick={handleExportFile}
              style={{ marginBottom: 10 }}
            >
              Export to Excel
            </IconButton> */}
          </Col>
        </Row>

        <OverallBudgetReportTable data={formSchema?.forms?.values} />
      </Panel>
    </>
  )
}
